/** A call while the same key is in flight, or up to SHARE_MS after it ends, gets the same answer. */
export const SHARE_MS = 5_000;

/** The key of GET /api/routes for today; it is not a key of a kept record. */
export const ROUTE_DAY_GET = "get:route-day";

const shared = new Map<string, { work: Promise<unknown>; ended: number | null }>();

/** One GET for the parts of one page load that need the same answer, for example the route day of Sync and of the offline copy. */
export function shareFetch<T>(key: string, load: () => Promise<T>): Promise<T> {
  const found = shared.get(key);
  if (found && (found.ended === null || Date.now() - found.ended < SHARE_MS)) {
    console.info(`share: ${key.split(":").slice(-2).join(":")} uses the answer of a call in this page load`);
    return found.work as Promise<T>;
  }
  const entry: { work: Promise<T>; ended: number | null } = { work: load(), ended: null };
  shared.set(key, entry);
  entry.work.then(
    () => {
      entry.ended = Date.now();
    },
    () => {
      if (shared.get(key) === entry) shared.delete(key);
    },
  );
  return entry.work;
}

/** For tests: forget each shared answer. */
export function forgetShared(): void {
  shared.clear();
}
